export const TIME_ZONE_FORMAT = [
  { value: 'UTC-12:00', label: '(UTC-12:00) International Date Line West' },
  { value: 'UTC-11:00', label: '(UTC-11:00) Coordinated Universal Time-11' },
  { value: 'UTC-10:00', label: '(UTC-10:00) Hawaii' },
  { value: 'UTC-09:00', label: '(UTC-09:00) Alaska' },
  { value: 'UTC-08:00', label: '(UTC-08:00) Baja California, Pacific Time (US and Canada)' },
  { value: 'UTC-07:00', label: '(UTC-07:00) Chihuahua, La Paz, Mazatlan, Arizona, Mountain Time (US and Canada)' },
  {
    value: 'UTC-06:00',
    label: '(UTC-06:00) Central Time (US and Canada), Saskatchewan, Guadalajara, Mexico City, Monterey',
  },
  { value: 'UTC-05:00', label: '(UTC-05:00) Eastern Time (US and Canada), Bogota, Lima' },
  { value: 'UTC-04:00', label: '(UTC-04:00) Atlantic Time (Canada), Caracas, La Paz' },
  { value: 'UTC-03:30', label: '(UTC-03:30) Newfoundland' },
  { value: 'UTC-03:00', label: '(UTC-03:00) Brazil, Buenos Aires, Georgetown' },
  { value: 'UTC-02:00', label: '(UTC-02:00) Mid-Atlantic' },
  { value: 'UTC-01:00', label: '(UTC-01:00) Azores, Cape Verde Islands' },
  { value: 'UTC+00:00', label: '(UTC+00:00) Greenwich Mean Time: Dublin, Edinburgh, Lisbon, London' },
  { value: 'UTC+01:00', label: '(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna' },
  { value: 'UTC+02:00', label: '(UTC+02:00) Athens, Bucharest, Istanbul, Cairo' },
  { value: 'UTC+03:00', label: '(UTC+03:00) Moscow, St. Petersburg, Volgograd, Nairobi' },
  { value: 'UTC+03:30', label: '(UTC+03:30) Tehran' },
  { value: 'UTC+04:00', label: '(UTC+04:00) Abu Dhabi, Muscat, Baku, Tbilisi' },
  { value: 'UTC+04:30', label: '(UTC+04:30) Kabul' },
  { value: 'UTC+05:00', label: '(UTC+05:00) Ekaterinburg, Islamabad, Karachi, Tashkent' },
  { value: 'UTC+05:30', label: '(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi' },
  { value: 'UTC+05:45', label: '(UTC+05:45) Kathmandu' },
  { value: 'UTC+06:00', label: '(UTC+06:00) Almaty, Novosibirsk, Astana, Dhaka' },
  { value: 'UTC+06:30', label: '(UTC+06:30) Yangon (Rangoon)' },
  { value: 'UTC+07:00', label: '(UTC+07:00) Bangkok, Hanoi, Jakarta' },
  { value: 'UTC+08:00', label: '(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi, Kuala Lumpur, Singapore' },
  { value: 'UTC+09:00', label: '(UTC+09:00) Osaka, Sapporo, Tokyo, Seoul' },
  { value: 'UTC+09:30', label: '(UTC+09:30) Adelaide, Darwin' },
  { value: 'UTC+10:00', label: '(UTC+10:00) Brisbane, Canberra, Melbourne, Sydney, Guam, Port Moresby' },
  { value: 'UTC+11:00', label: '(UTC+11:00) Solomon Islands, New Caledonia' },
  { value: 'UTC+12:00', label: '(UTC+12:00) Fiji, Kamchatka, Marshall Islands' },
  { value: 'UTC+13:00', label: `(UTC+13:00) Nuku'alofa` },
];
